import { CountUp } from "countup.js";
export function importGoogleTranslate(opts?: GoogleTranslate) {
  const trigger = opts?.trigger || "language-trigger";
  const wrapper = opts?.wrapper || "language";
  const src = opts?.src || "//translate.google.com/translate_a/element.js?cb=loadPlugin";
  const renderCSS = opts?.renderCSS || false;
  const buttonTrigger = document.getElementById(trigger) as HTMLElement;
  const pluginContainer = document.getElementsByClassName(wrapper)[0] as HTMLElement;
  const tag = document.createElement("script");
  const styleSheel = document.createElement("style");
  styleSheel.type = "text/css";
  styleSheel.innerHTML = "";
  tag.async = true;
  tag.defer = true;
  tag.src = src;
  tag.onerror = () => {
    console.error("Failed to load Google Translate script");
  };
  document.getElementsByTagName("head")[0].appendChild(tag);
  if (renderCSS) {
    document.getElementsByTagName("head")[0].appendChild(styleSheel);
  }
  const loadPlugin = () => {
    try {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          autoDisplay: true,
        },
        "google_translate_element"
      );
      buttonTrigger?.addEventListener("click", () => {
        buttonTrigger.style.display = "none";
        pluginContainer.style.display = "block";
      });
      window.loadPlugin = null;
    } catch (error) {
      console.error("Error initializing Google Translate plugin:", error);
    }
  };
  window.loadPlugin = loadPlugin;
}
export function countUp(target: string = ".counter", opts: any = {}) {
  const List = $(target);
  if (!List.length) return;
  let defaults = {
    startVal: 0,
    enableScrollSpy: true,
    duration: 0.7,
    useEasing: false,
    scrollSpyDelay: 0,
    scrollSpyOnce: true,
    ...opts,
  };
  List.each((_i, item) => {
    const Num = Number($(item).text());
    if (!Num || typeof Num !== "number") return;
    // const symbol = $(item).attr("data-symbol");
    // if (symbol) {
    //   defaults[opts.isPrefix ? "prefix" : "suffix"] = symbol;
    // }
    new CountUp(item, Num, defaults);
  });
}
/* 点击展开尊贵版（filpHeight） */
export function filpHeight(btn: string | HTMLElement, content: string | HTMLElement, L: number) {
  const BTN = typeof btn === 'string' ? $(btn) : $(btn as HTMLElement);
  const CONTENT = typeof content === 'string' ? $(content) : $(content as HTMLElement);
  if (!CONTENT.length || !BTN.length) return;
  CONTENT.css("height", "auto");
  const LH = (CONTENT.css("lineHeight") ? parseInt(CONTENT.css("lineHeight").replace("px", "")).toFixed(2) : 32) as number;
  const H = CONTENT.outerHeight();
  CONTENT.css("-webkit-line-clamp", L + "");
  const minH = CONTENT.height() as number;
  const showH = minH == H ? (L * LH > minH ? minH : L * LH) : minH;
  CONTENT.css("-webkit-line-clamp", "unset");
  CONTENT.css("transition", ".3s ease-out");
  function filp() {
    CONTENT.toggleClass("active");
    const FLAG = CONTENT.hasClass("active");
    if (FLAG) {
      CONTENT.css("height", showH + "px");
      CONTENT.css("overflow", "hidden");
      setTimeout(function () {
        CONTENT.css("-webkit-line-clamp", L + "");
      }, 300);
    } else {
      CONTENT.css("height", H + "px");
      CONTENT.css("-webkit-line-clamp", "unset");
    }
  }
  filp();
  BTN.on("click", filp);
}
/*! 平均分圆 */
export function circleRender(that: string) {
  const PARENT = $(that).parent().parent();
  const ITEM = $(that);
  const r = PARENT.width()! / 2;
  const COUNT = ITEM.length;
  const pieceDeg = 360 / COUNT;
  for (let i = 0; i < COUNT; i++) {
    let t = 180 - i * pieceDeg;
    t = (Math.PI / 180) * t;
    const X = $(ITEM[i]).outerWidth()! / 2;
    const Y = $(ITEM[i]).outerHeight()! / 2;
    const x = Math.sin(t) * r - X;
    const y = Math.cos(t) * r - Y;
    $(ITEM[i]).css({
      transform: `translate(${x}px,${y}px)`,
    });
  }
}
interface MagnifierOptions {
  width?: number;
  height?: number;
  scale?: number;
}

export class ImageMagnifier {
  private lens: HTMLElement;
  private width: number;
  private height: number;
  private scale: number;
  private rAFId: number | null = null;

  constructor(opts: MagnifierOptions = {}) {
    this.width = opts.width ?? 180;
    this.height = opts.height ?? 180;
    this.scale = opts.scale ?? 1.5;
    this.lens = document.createElement("div");
    this.lens.className = "magnifier-viewBox";
    this.setupLens();
    this.attachEvents();
  }

  private setupLens(): void {
    this.lens.classList.add("magnifier-lens");
    this.lens.style.width = `${this.width / 10}rem`;
    this.lens.style.height = `${this.height / 10}rem`;
    this.lens.style.borderRadius = "50%";
    this.lens.style.position = "fixed";
    this.lens.style.top = "0";
    this.lens.style.left = "0";
    this.lens.style.border = "2px solid #000";
    this.lens.style.visibility = "hidden";
    this.lens.style.pointerEvents = "none";
    this.lens.style.zIndex = "999";
    this.lens.style.backgroundRepeat = "no-repeat";
    this.lens.style.backdropFilter = "blur(2rem)";
    document.querySelectorAll<HTMLImageElement>("img.magnifier").forEach((img) => {
      img.style.cursor = "none";
    });
    document.body.appendChild(this.lens);
  }

  private attachEvents(): void {
    const images = document.querySelectorAll<HTMLImageElement>(".magnifier");
    images.forEach((img) => {
      img.addEventListener("mousemove", this.onMouseMove);
      img.addEventListener("mouseout", this.onMouseOut);
    });
  }

  private onMouseMove = (e: MouseEvent): void => {
    const img = e.currentTarget as HTMLImageElement;
    if (this.rAFId) {
      cancelAnimationFrame(this.rAFId);
    }
    this.rAFId = requestAnimationFrame(() => {
      if (img) {
        this.moveLens(img, e);
      }
    });
  };

  private onMouseOut = (): void => {
    this.hideLens();
  };

  private moveLens(img: HTMLImageElement, e: MouseEvent): void {
    const rect = img.getBoundingClientRect();
    const posX = e.clientX - rect.left;
    const posY = e.clientY - rect.top;
    const lensX = e.clientX - this.width / 2;
    const lensY = e.clientY - this.height / 2;

    // 优化后的样式修改，减少DOM操作
    this.lens.style.transform = `translate(${lensX}px, ${lensY}px)`;
    this.lens.style.backgroundImage = `url('${img.src}')`;
    const bgX = -(posX * this.scale - this.width / 2);
    const bgY = -(posY * this.scale - this.height / 2);
    this.lens.style.backgroundSize = `${img.width * this.scale}px ${img.height * this.scale}px`;
    this.lens.style.backgroundPosition = `${bgX}px ${bgY}px`;
    this.lens.style.visibility = "visible";
    this.lens.style.transition = "visibility 0.1s ease-out,opacity 0.15s ease-out";
    this.lens.style.opacity = "1";
  }

  private hideLens(): void {
    if (this.rAFId) {
      cancelAnimationFrame(this.rAFId);
      this.rAFId = null;
    }
    this.lens.style.transition = "visibility 0.1s ease-out,opacity 0.15s ease-out";

    this.lens.style.opacity = "0";
    this.lens.style.visibility = "hidden";
  }
}
